module.exports = __webpack_public_path__ + "img/phone_case.f584889a.png";